import * as React from 'react';
import styled from 'styled-components';

export enum Sizes {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg'
}

export interface LoadingIndicatorProps {
  size: Sizes;
}

const StyledLoadingIndicator = styled.div`
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0078ae;

  &.loading-component-sm {
  font-size: 25px;
  }

  &.loading-component-md {
    font-size: 37.5px;
  }

  &.loading-component-lg {
    font-size: 50px;
  }
`;

export const LoadingIndicator: React.SFC<LoadingIndicatorProps> = (props) => {
  return (
    <StyledLoadingIndicator
      className={`ns-icon ns-loading loading-component-${props.size}`}
      data-testid="loadingIndicator"
    />
  );
};
